import variables from '../scss/_variables.scss';
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: variables.redDabi,
    },
    secondary: {
      main: variables.secondaryRedDabi,
    },
  },
});

export default theme;
